import { AppData } from "../../AppDataProvider";
import { Mixpanel } from "../../../mixpanel";

export type BackFromPricePointsStepOpts = { appData: AppData };

export const backFromPricePointsStep = ({
  appData,
}: BackFromPricePointsStepOpts): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "pricePoints" } });

  if (appData.bookingData.pricePoints) delete appData.bookingData.pricePoints;

  return {
    ...appData,
    currentStep: "multiTier",
  };
};
